import VisibleIcon from "@rsuite/icons/Visible";
import { Edit, Trash, More } from "@rsuite/icons";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { orderStatusObj, statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { Button, Table } from "rsuite";
import { isEmpty } from "lodash";
import ViewOrdersModal from "./ViewOrdersModal";
const { Cell } = Table;

const GroupedOrderSingleAction = ({
  rowData,
  orderFilterData,
  ...props
}: {
  rowData?: any;
  orderFilterData?: any;
}) => {
  if (!isEmpty(rowData.service_hour)) {
    orderFilterData = {
      ...orderFilterData,
      ...{ service_hour: rowData.service_hour },
    };
  }

  const { t } = useTranslation();
  const orderRef = useRef({});
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleEvent = (eventKey: any) => {
    setOpenModalByName(eventKey);
    dispatch(setActionData(orderFilterData));
  };
  return (
    <Cell {...props} style={{ padding: "6px" }}>
      <div>
        <Button
          appearance="link"
          onClick={() => {
            handleEvent("view-orders");
          }}
          title={t("VIEW") + " " + t("ORDERS")}
        >
          <VisibleIcon />
        </Button>

        {openModalByName === "view-orders" && (
          <ViewOrdersModal
            orderFilterData={orderFilterData}
            openModal={openModalByName === "view-orders" ? true : false}
            setOpenModal={setOpenModalByName}
          />
        )}
      </div>
    </Cell>
  );
};

export default GroupedOrderSingleAction;
